module.exports = __webpack_public_path__ + "static/img/2电力.c079bcdd.jpg";